var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"last-played-last-played grid-pasttrack"},_vm._l((_vm.lastTracks),function(track){return _c('last-track',{key:track.name,attrs:{"artist":track.artist,"title":track.title,"album":track.album,"year":track.year,"discogsUrl":track.discogs_url,"spotifyUri":track.spotify_uri,"imageUrl":track.image_url}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }